<template>

    <div>
        <loading />
        <header-cna />
        <router-view />
    </div>

</template>
<script>

    import headerCna from '@/template/header'
    import loading from '@/common/components/loading'
    import { Api } from '@/common/api'

    export default {
        name: "Template",
        components: { headerCna, loading },
        data() {
            return {

            };
        },
        watch: {
            '$route'(to) {

            }
        },
        methods: {
        },
        mounted() {
        },
        beforeDestroy() {
        },
    };
</script>
